<template>
  <div>
    <input
      class="hidden"
      :accept="accept"
      :id="id"
      :multiple="multiple"
      type="file"
      @change="onUpload($event)"
    />
    <form-button
      :command="() => openFileDialog()"
      :disabled="disabled"
      :id="`${id}-button`"
      :label="label"
      :textVariant="textVariant"
      type="button"
      :variant="variant"
    />
    <div v-if="showFilename" class="flex flex-wrap gap-2 pt-2">
      <div v-for="file in files" class="flex items-center gap-1">
        <CheckCircleIcon class="h-6 w-6 text-green-600" />{{ file.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon } from "@heroicons/vue/24/outline";
import { ref, watch } from "vue";
import FormButton from "./FormButton.vue";
export default {
  components: { CheckCircleIcon, FormButton },
  props: {
    accept: {
      required: true,
      type: String,
    },
    disabled: {
      required: true,
      type: Boolean,
    },
    id: {
      required: false,
      type: String,
    },
    invalid: {
      default: false,
      required: false,
      type: Boolean,
    },
    label: {
      default: "choose_file",
      type: String,
    },
    modelValue: {},
    multiple: {
      default: false,
      type: Boolean,
    },
    showFilename: {
      default: false,
      type: Boolean,
    },
    textVariant: {
      default: "light",
      type: String,
    },
    variant: {
      default: "indigo",
      type: [Object, String],
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const files = ref(props.modelValue);

    const openFileDialog = () => {
      document.getElementById(props.id).click();
    };

    const getBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    const onUpload = (event) => {
      for (const file of event.target.files) {
        getBase64(file).then((data) => {
          const fileData = {
            name: file.name,
            file: data,
          };
          if (props.multiple) {
            files.value.push(fileData);
          } else {
            files.value = [fileData];
          }
        });
      }
    };

    watch(
      () => files.value,
      (filesData) => {
        emit("update:modelValue", filesData);
      },
      {
        deep: true,
      }
    );

    return {
      files,
      onUpload,
      openFileDialog,
    };
  },
};
</script>
